module.exports = __webpack_public_path__ + "media/images/dividend/il_coupontheme_valentines-886df3af14f2a3234b6fcb798c7e90c5.svg";